import React from 'react';

import CloseIcon from './icons/CloseIcon';

interface SearchClearButtonProps {
  /** Removed from the layout while there is nothing to clear, like the native button. */
  visible: boolean;
  onClear: () => void;
  className?: string;
}

/**
 * Clears a search field. Stands in for the browser's native search cancel
 * button, which style.css hides because it differs per browser and ignores
 * the theme.
 */
const SearchClearButton: React.FC<SearchClearButtonProps> = ({ visible, onClear, className }) => (
  <button
    type="button"
    aria-label="Clear search"
    // Keep focus in the field so the user can carry on typing.
    onMouseDown={(event) => event.preventDefault()}
    onClick={onClear}
    className={`${
      visible ? 'flex' : 'hidden'
    } shrink-0 cursor-pointer items-center justify-center rounded-full opacity-60 transition-opacity hover:opacity-100 ${className ?? ''}`}
  >
    <CloseIcon size="sm" strokeWidth={2} />
  </button>
);

export default SearchClearButton;
